import React, {useEffect, useState, useRef} from "react";
import {Button, Form} from "antd";
import {FormBox, InputBox} from "../AntdAddons";
import {ReactComponent as ArrowRight} from "../../assets/images/icon/backToTop.svg";
// import { ReactComponent as ReloadIcon } from "../../assets/images/icon/refresh.svg";
import {randomnumbersubstring} from "../../utils/GlobalFunction";
import ReCAPTCHA from "react-google-recaptcha";
import {createContactUsRecord} from "../../store/CommonSlice";
import {useAppDispatch} from "../../store/app";
import {assignErrorToInput} from "../../store/api";
import {rules} from "./rules";
import {validateFields} from "../../config/Global";

const FormComponent: React.FC<any> = () => {
    const [form] = Form.useForm();
    const [disabledSave, setDisabledSave] = useState(true);
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const dispatch = useAppDispatch();

    const onChange = (value: string | null) => {
        if (value) {
            setDisabledSave(false); // Enable the button when the reCAPTCHA is completed
        } else {
            setDisabledSave(true); // Disable the button when the reCAPTCHA is not completed
        }
    };

    const resetCaptcha = () => {
        form.setFieldsValue({captcha: randomnumbersubstring()});
        if (recaptchaRef.current) {
            recaptchaRef.current.reset();
            setDisabledSave(true); // Disable the button when the reCAPTCHA is reset
        }
    };

    useEffect(() => {
        form.setFieldsValue({captcha: randomnumbersubstring()});
    }, [form]);

    const onValuesChange = () => {
        validateFields(form, setDisabledSave);
    };

    const handleSubmit = (values: any) => {
        // Handle form submission logic here
        setDisabledSave(true);
        // values.captcha = recaptchaRef?.current?.getValue();
        const multipartFormData = new FormData();
        multipartFormData.append("name", values.contact_name);
        multipartFormData.append("email", values.contact_email);
        multipartFormData.append("subject", values.contact_subject);
        multipartFormData.append("message", values.contact_message);
        multipartFormData.append("captcha", values.captcha);
        dispatch(createContactUsRecord(multipartFormData))
            .then(() => {
                form.resetFields();
                resetCaptcha();
                setDisabledSave(false);
            })
            .catch((error: any) => {
                assignErrorToInput(form, error?.messages);
            })
            .finally(() => setDisabledSave(false));
    };

    return (
        <div className="footerForm">
            <h2>
                Let&apos;s <span>Discuss!</span>
            </h2>

            <FormBox form={form} onFinish={handleSubmit} onValuesChange={onValuesChange}>
                <InputBox.Text
                    required
                    placeholder="Your Name"
                    name="contact_name"
                    rules={rules.name()}
                />
                <InputBox.Text
                    required
                    placeholder="Your email"
                    name="contact_email"
                    rules={rules.email()}
                />
                <InputBox.Text placeholder="Subject" name="contact_subject" required />
                <InputBox.TextArea placeholder="Message.." name="contact_message" required />
                <div className="captchaWrap">
                    <Form.Item name="captcha">
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={`${process.env.REACT_APP_CAPTCHA_SITE_KEY}`} // site key
                            onChange={onChange}
                        />
                    </Form.Item>
                </div>
                <div
                    style={{
                        width: "100%",
                        position: "relative",
                        zIndex: "9999",
                    }}
                >
                    <Button className="commanBtn" htmlType="submit" disabled={disabledSave}>
                        <span className="arrowIcon">
                            <ArrowRight />
                        </span>
                        <span className="beforeIcon"></span>
                        Get a Quote
                    </Button>
                </div>
            </FormBox>
        </div>
    );
};

export default FormComponent;
